export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9151.b50eca53.jpg";